import Operator from "@/utils/constants/Operator.ts";
import ExpressionRelationship from "@/utils/constants/ExpressionRelationship.ts";
import DTOExperssion = namaTypes.DTOExperssion;

export default class HierarchyFilterHelper {
  propertyName: string;

  constructor(propertyName: string) {
    this.propertyName = propertyName;
  }

  createSelectedNodeExpressions(selectedNodeId: string | null | undefined): DTOExperssion[] {
    if (!selectedNodeId)
      return [];
    return [this.createFilter(selectedNodeId)];
  }

  createFilter(value: string): DTOExperssion {
    return {
      field: this.propertyName,
      operator: Operator.Contains,
      rightHandSide: value.replaceAll("-", ""),
      relation: ExpressionRelationship.AND
    };
  }

}
